module.exports = __webpack_public_path__ + "img/logo-apoio.1c4a12ea.png";